import React, { createContext } from 'react';
/**
 * Set on the frame while suggestions attached below a framed input cover its chin. Portaled
 * suggestions inherit it to rise from below the frame to the input's bottom edge.
 */
export const COVERED_CHIN_HEIGHT_PROPERTY = '--composer-covered-chin-height';
export const ComposerContainerContext = createContext({
    hasMask: false,
    isFramed: false,
    isInsideFramedHeader: false,
    decorativeGlow: undefined,
    setDecorativeGlow: undefined,
});
ComposerContainerContext.displayName = 'ComposerContainerContext';
//# sourceMappingURL=ComposerContainerContext.js.map